import React from "react";

import { useContext } from "react";
import Container from "../components/Container";
import CustomHead from "../components/CustomHead";
import Layout from "../components/Layout";
import ContentTemplate from "../components/Layout/contentTemplate";
import TopicHeader from "../components/TopicHeader";
import loadDataFromApi from "../utils/fetch";
import fetchRequestLibrary from "../utils/fetchRequestLibrary";
import { Context } from "../utils/store";

export default function ComptesAnnuels({
  thematiques,
  breakingNews,
  cities,
  ephemeralChannels,
  liveData,
  medias,
  auboisVousInforment,
  teams,
}) {
  const context = useContext(Context);
  return (
    <Context.Provider
      value={{
        ...context,
        activePage: "comptesAnnuels",
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
        auboisVousInforment,
      }}
    >
      <Layout>
        <Container>
          <CustomHead title="Comptes annuels" />
          <ContentTemplate type={"comptesAnnuels"}>
            <TopicHeader topic={"Comptes annuels"} type={"comptesAnnuels"} />
          </ContentTemplate>
        </Container>
      </Layout>
    </Context.Provider>
  );
}

export async function getServerSideProps(context) {
  const {
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
    auboisVousInforment,
  } = await fetchRequestLibrary();

  let teams = await loadDataFromApi(
    `${process.env.SOURCE_API}rest/2.0/categories/getTeamsMembers.php`,
    "POST"
  );

  return {
    props: {
      thematiques,
      breakingNews,
      cities,
      ephemeralChannels,
      liveData,
      medias,
      auboisVousInforment,
      teams,
    },
  };
}
